import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import {
  InfoBlockConfig,
  InfoBlockLinkType,
  InfoBlockModule,
  InfoBlockType,
} from '@commons/info-block/info-block.component';
import { environment } from '@environment';
import { trackEventWithAtInternet } from '@wizbii/tracking';

@Component({
  selector: 'app-cidj-block',
  templateUrl: './cidj-block.component.html',
  styleUrls: ['./cidj-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CidjBlockComponent {
  trackEvent = trackEventWithAtInternet;

  cidjBlockInfo: InfoBlockConfig = {
    type: InfoBlockType.CENTER,
    title: {
      main: 'Besoin d’information',
      emphasis: 'sur les métiers ?',
    },
    button: {
      link: 'https://www.cidj.com/orientation-metiers',
      type: InfoBlockLinkType.HREF,
      text: 'En savoir plus',
      ariaLabel: 'Lien vers le site cidj.com/orientation-metiers',
    },
    img: {
      src: `${environment.wizbiiImages}/cidj/cidj-logo.png`,
    },
  };

  onTrackerCidjBlockClicked(action: string): void {
    this.trackEvent({ category: 'Cidj', action, type: 'navigation' });
  }
}

@NgModule({
  imports: [InfoBlockModule],
  declarations: [CidjBlockComponent],
  exports: [CidjBlockComponent],
})
export class CidjBlockModule {}
